export default "__VITE_ASSET__B0iuJvr7__"